<template>
    <div id="my-modal" v-if="store.state.dialogBox.visible">
        <div id="my-modal-background" class="b3-modal">
            <div id="my-modal-content-area">
                <p>{{ store.state.dialogBox.title }}</p>
            </div>
            <input
                v-if="store.state.dialogBox.showTextInput"
                id="my-modal-text-input"
                type="text"
                maxlength="100"
                v-model="store.state.dialogBox.textInputValue"
            />
            <div id="my-modal-buttons">
                <button @click="success()">{{t('modal OK button','OK')}}</button>
                <button @click="cancel()">{{t('cancel','Cancel')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dialog Box',
    methods: {
        success() {
            b3.modalSuccess();
        },
        cancel() {
            b3.modalCancel();
        }
    }
}
</script>

<style lang="scss">
@import '../assets/colors.scss';

#my-modal {
    z-index: 1;
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(90, 90, 90, 0.6);
    z-index: 1;

    #my-modal-background {
        background-color: $off_white;
        width: 250px;
        text-align: center;
        top: 100px;
        border-radius: 5px;
        padding: 0 5px 15px;
        input {
            position: relative;
        }
    }
    #my-modal-buttons {
        margin: 10px 0 0;
        button {
            margin-right: 15px;
        }
    }
}

</style>